import { type ProjectContent } from "@/types/content";
import { create } from "zustand";

interface AppState {
  project: ProjectContent | null;
  setProject: (project: ProjectContent | null) => void;
  resetProjectStore: () => void;
}

const initialState = {
  project: null,
};

const useProjectStore = create<AppState>()((set) => ({
  ...initialState,
  setProject: (project: ProjectContent | null) => {
    set({ project });
  },
  resetProjectStore: () => {
    set(initialState);
  },
}));

export default useProjectStore;
